import React, { useCallback } from 'react'
import { FiPauseCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import { Spinner } from '~/components/Spinner'
import useConfirmationModal from '~/hooks/useConfirmationModal'

import useFlyers from '../../hooks/useFlyers'

const PauseButton = ({ data, keepsMenuOpen, menuItem = false }) => {
  const [ConfirmationhModal, showConfirmationModal, toggleConfirmationModal] =
    useConfirmationModal()

  const { handlePauseFlyer } = useFlyers()

  const { loading } = useSelector(
    ({ promotionFlyer }) => promotionFlyer.flyers.update
  )

  const handleToogle = useCallback(() => {
    keepsMenuOpen && keepsMenuOpen(oldState => !oldState)

    toggleConfirmationModal()
  }, [keepsMenuOpen, toggleConfirmationModal])

  const handleSubmit = useCallback(() => {
    const body = {
      data,
      onSuccess: handleToogle
    }

    handlePauseFlyer(body)
  }, [handlePauseFlyer, data, handleToogle])

  return (
    <>
      {menuItem ? (
        <button type="button" onClick={handleToogle} className="warning">
          {loading ? <Spinner /> : <FiPauseCircle />} <span>Pausar</span>
        </button>
      ) : (
        <Button
          text="Pausar"
          type="button"
          template="warningOutlined"
          size="small"
          iconLeft={loading ? <Spinner /> : <FiPauseCircle />}
          customWidth="auto"
          onClick={handleToogle}
        />
      )}

      {/* Modal Pausar */}
      <ConfirmationhModal
        title="Deseja pausar o encarte?"
        isOpen={showConfirmationModal}
        onClose={handleToogle}
        onSubmit={handleSubmit}
        confirmationButton="Entendo e desejo pausar este encarte"
      >
        <p>
          O encarte não será finalizado e você poderá reativá-lo a qualquer
          monento até a data de término.
        </p>
        {loading && <Loading status={loading}>Pausando encarte...</Loading>}
      </ConfirmationhModal>
    </>
  )
}

export default PauseButton

PauseButton.propTypes = {
  data: PropTypes.shape({}).isRequired,
  keepsMenuOpen: PropTypes.func,
  menuItem: PropTypes.bool
}

PauseButton.defaultProps = {
  menuItem: false,
  keepsMenuOpen: null
}
